export const BANNER_HEIGHT = 48;
